import { render, staticRenderFns } from "./EducationAdvantage.vue?vue&type=template&id=147d9090&"
import script from "./EducationAdvantage.vue?vue&type=script&lang=js&"
export * from "./EducationAdvantage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports